import {addCorporateSigners} from '../../components/corporate'

const init = () => {
  addCorporateSigners()
}

export default init
